import { useTranslation } from 'react-i18next';

export const InviteNotFound = () => {
  const { t } = useTranslation(['common']);
  return (
    <div className="flex flex-col items-center justify-center h-full space-y-4">
      <h1 className="text-lg font-bold">{t('Your Invite Was Not Found')}</h1>
      <p>
        {t(
          'It may have expired or has already been used. Please reach out to the person who invited you to receive another invite.'
        )}
      </p>
    </div>
  );
};

export default InviteNotFound;
